module.exports = __webpack_public_path__ + "static/media/notebook_cnl.f6007a2f.png";